import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/homeimg.png";
import Home2 from "./Home2";
import Type from "./Type";
// import HeroBgAnimation from '../HeroBgAnimation'
// import {HeroBg, HeroRightContainer,Img} from './HeroStyle'
import {HeroRightContainer,Img} from './HeroStyle'
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { BiLogoTelegram } from "react-icons/bi";
import { ImProfile } from "react-icons/im";
function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
      {/* <HeroBg>
                    <HeroBgAnimation />
                </HeroBg> */}
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
 
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> DHINAKARAN S</strong>
              </h1>
              <div className="typepara">
                <Type />
              </div><div className="parahome">
              <h6>I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.</h6>
              <a href="/contact"><button className="button-two"><span>Contact Me<a href="/contact"style={{ marginLeft: '5px' }}><BiLogoTelegram style={{ color: 'white' }} /></a></span></button></a>
              <a href="/resume"><button className="button-twotwo"><span>Resume<a href="/resume"style={{ marginLeft: '5px' }}><ImProfile /></a></span></button></a>
              <p className="p-home">
              Feel free to <span className="purple">connect </span>with me
            </p>
              <li className="top-social">
                <a
                  href="https://github.com/dhinakaran2425"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/DhinakaranS25"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/dhinakaransrinivasan/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/dhinakaran__"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              </div>
          </Col>
            {/* <Col md={5} style={{ paddingBottom: 20 }}>
              <img src={homeLogo} alt="home pic" className="img-fluid" />
            </Col> */}
            
                <HeroRightContainer>

                        <Img src={homeLogo} alt="hero-image" />
                        
                    </HeroRightContainer>
                
          </Row>
        </Container>
        
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
